var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bulk-message-recipients-import-upload"},[_c('ContactImportUpload',{attrs:{"override-import-type":'bulk-message-recipients',"pageCopy":_vm.page_copy,"fieldDefinitions":_vm.field_definitions,"previewConfig":_vm.preview_config,"targetBulkMessageName":_vm.target_bulk_message_name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }